import React, { ReactElement } from 'react';
import { ListRenderer } from '@feast-it/ui/light';
import { MAX_SUPPLIERS_V2 } from '../../../../constants/suppliers';
import {
  Container,
  SkeletonHeaderContainer,
  SkeletonTitle,
  SkeletonDescription,
} from './SuppliersSkeleton.styled';
import { SkeletonCard } from '../SkeletonCard';

import { Container as SuppliersGridContainer } from '../SuppliersGrid/SuppliersGrid.styled';

export function SuppliersSkeleton(): ReactElement {
  return (
    <>
      <Container>
        <SkeletonHeaderContainer>
          <SkeletonTitle height={44} rows={1} />
          <SkeletonDescription height={32} rows={1} />
        </SkeletonHeaderContainer>

        <SuppliersGridContainer>
          <ListRenderer
            items={Array.from({ length: MAX_SUPPLIERS_V2 }, (_, i) => i + 1)}
            render={() => <SkeletonCard />}
          />
        </SuppliersGridContainer>
      </Container>
    </>
  );
}
